export const getFaviconPath = (brand?: string): string => {
	switch (brand) {
		case 'pm':
			return '/favicon.ico';
		case 'nomad':
			return '/nomad-favicon.ico';
		case 'ngu3':
			return '/johnny-favicon.ico';
		case 'com2':
			return '/vip-favicon.ico';
		case 'rockets':
			return '/rockets-favicon.ico';
		case 'sk2':
			return '/sk2-favicon.ico';
		default:
			return '/favicon.ico';
	}
};
